import { IntegrationInterface } from '../../interfaces/components/integrations/IntegrationInterface';

export class IntegrationStoppedExecutionException extends Error {
  public constructor (private readonly integration: IntegrationInterface) {
    super();
  }

  public getIntegration (): IntegrationInterface {
    return this.integration;
  }
}
